import { render, staticRenderFns } from "./TemporaryItems.vue?vue&type=template&id=54d2b236&scoped=true&"
import script from "./TemporaryItems.vue?vue&type=script&lang=js&"
export * from "./TemporaryItems.vue?vue&type=script&lang=js&"
import style0 from "./TemporaryItems.vue?vue&type=style&index=0&id=54d2b236&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d2b236",
  null
  
)

export default component.exports